import moment from 'moment'
import React from 'react'
import {PDFDownloadLink, Document, Page, Text, View } from '@react-pdf/renderer'
import {Header, Title} from './common'
import PlanInfo from './plan-info'
import Standards from './standards'
import Field from './field'
import styles from './styles'
import {groupPlanningPdfStandards} from 'components/standards-selector/domain/planning-pdf.cjs'

export default function DownloadLink ({plan, fileName, className, children, headerTitle}) {
  return (
    <PDFDownloadLink className={className} fileName={fileName} document={<PDFDocument {...{...plan, headerTitle}} />}>
    {children}
    </PDFDownloadLink>
  )
}

export function parseContext(context, newPlan) {
  const format = date => moment(date).format('MM/DD/YYYY')
  const {translate, profile, subjects, grades, groups} = context
  const {individual, institution} = profile
  const {content = {}, title = ''} = newPlan

  const planStart = format(newPlan.start)
  const planEnd = format(newPlan.finish)
  const subject = subjects.find(subject => subject.id == newPlan.subject)
  const grade = grades.find(grade => grade.id == newPlan.grade)
  const group = groups.find(group => group.id == newPlan.clique)
  /* Edition-aware hierarchy replaces the legacy ID-only reducer below. */
  const groupedStandards = groupPlanningPdfStandards(content.standards || [], context.teacherExpectations, context.teacherStandards)


  return {
    ...newPlan,
    translate,
    planStart,
    planEnd,
    institution,
    author: {name: individual.first_name, lastName: individual.last_name}, 
    subject,
    grade,
    group,
    groupedStandards,
    lessons: content.lessons || [],
    resources: content.resources || [],
    items: newPlan.items || []
  }
}

export function PDFDocument (plan) {
  return (
    <Document style={styles.document}>
      <Page size="A4" style={styles.page} wrap>
        <Header>
          <Text style={styles.headerTitle}>{plan.headerTitle}</Text>
        </Header>
        <View style={styles.content}> 
          <PlanInfo {...plan} />
          {plan.groupedStandards.length > 0 && (<Standards {...plan} />)}
          {plan.items.length > 0 && plan.items.map(field => (
            <Field
              key={field.id}
              className={field.name}
              name={field.content.name}
              context={plan}
              sections={field.content.sections}
            />
          ))}
        </View>
        <Text style={[styles.author, styles.footer]} fixed>
          {plan.author.name} {plan.author.lastName}
        </Text>
        <Text style={[styles.paging, styles.footer]} fixed render={ props => {
          const {pageNumber, totalPages} = props
          return totalPages ? `${pageNumber} / ${totalPages}` : `${pageNumber}`
        }} />
      </Page>
    </Document>
  )
}
